import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MathCaptcha from "../../Components/UI/MathCaptcha";
import "./TankerBooking.css"; // 👈 make sure you add the toast styles below

const TankerBooking = () => {
  const [mobileno, setMobileno] = useState("");
  const [villa_no, setvilla_no] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resetCaptcha, setResetCaptcha] = useState(false);
  const submittingRef = useRef(false);

  const [toast, setToast] = useState({ show: false, text: "", type: "" });

  // === Toast helper ===
  const showToast = (type, text, duration = 2000) => {
    setToast({ show: true, type, text });
    setTimeout(() => setToast({ show: false, type: "", text: "" }), duration);
  };

  const resetForm = () => {
    setvilla_no("");
    setMobileno("");
    setIsVerified(false);
    setResetCaptcha(true);
    setIsSubmitting(false);
    submittingRef.current = false;
  };

  useEffect(() => {
    if (resetCaptcha) setResetCaptcha(false);
  }, [resetCaptcha]);

  const Required = () => <span style={{ color: "red" }}>*</span>;

  const validateVillaNo = (villa_no) => /^[A-Za-z0-9]+$/.test(villa_no);
  const validateMobileNumber = (mobileno) => /^[6-9]\d{9}$/.test(mobileno);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submittingRef.current) return;

    submittingRef.current = true;
    setIsSubmitting(true);

    const trimmedVilla = villa_no.trim();
    const trimmedMobile = mobileno.trim();

    // Validation
    if (!trimmedVilla || !trimmedMobile) {
      showToast("error", "Please fill all required fields. (कृपया सभी आवश्यक जानकारी भरें)");
      return resetCaptchaAfterError();
    }

    if (!validateVillaNo(trimmedVilla)) {
      showToast("error", "Please enter a valid Villa/Plot No. (only letters and numbers, no spaces).");
      return resetCaptchaAfterError();
    }

    if (!validateMobileNumber(trimmedMobile)) {
      showToast("error", "Please enter a valid 10-digit mobile number starting with 6-9.");
      return resetCaptchaAfterError();
    }

    if (!isVerified) {
      showToast("error", "Please complete the captcha.");
      return resetCaptchaAfterError();
    }

    // === API CALL ===
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/Create_Booking`,
        {
          villa_no: trimmedVilla,
          mobile: trimmedMobile,
          Booked_By: trimmedMobile,
          Booking_Type: "System",
        }
      );

      if (response.status === 200 && response.data.status === "success") {
        showToast(
          "success",
          response.data.message || "Booking created successfully! (बुकिंग सफलतापूर्वक की गई!)"
        );
        resetForm();

        // short cooldown
        setTimeout(() => {
          submittingRef.current = false;
          setIsSubmitting(false);
        }, 1500);
        return;
      }

      showToast(response.data.status || "error", response.data.message || "Booking failed.");
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Something went wrong, try again later.";
      showToast("error", errorMessage);
    } finally {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setResetCaptcha(true);
      setTimeout(() => {
        submittingRef.current = false;
        setIsSubmitting(false);
      }, 1200);
    }
  };

  const resetCaptchaAfterError = () => {
    setResetCaptcha(true);
    setIsSubmitting(false);
    submittingRef.current = false;
  };

  return (
    <div className="container">
      {/* Toast Notification */}
      {toast.show && (
        <div className={`toast-message toast-${toast.type}`}>{toast.text}</div>
      )}

      <div className="admin-wrap">
        <div className="box-head">
          <span>Water Booking : जल बुकिंग</span>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="villa_no" style={{ display: "block", fontWeight: "bold", marginBottom: "8px" }}>
              Villa No./Plot No. (विला नंबर / प्लाट नंबर)
              <Required />
            </label>
            <input
              id="villa_no"
              type="text"
              name="villa_no"
              placeholder="Villa / Plot No"
              value={villa_no}
              onChange={(e) => setvilla_no(e.target.value.toUpperCase())}
              disabled={isSubmitting}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="mobileno" style={{ display: "block", fontWeight: "bold", marginBottom: "8px" }}>
              Registered Mobile No. (पंजीकृत मोबाइल नंबर)
              <Required />
            </label>
            <input
              id="mobileno"
              type="text"
              name="mobileno"
              placeholder="Mobile No"
              value={mobileno}
              onChange={(e) => {
                let value = e.target.value.replace(/\D/g, "");
                if (value.length > 10) value = value.slice(-10);
                setMobileno(value);
              }}
              disabled={isSubmitting}
              required
            />
          </div>

          <div className="form-group" style={{ marginBottom: "8px" }}>
            <MathCaptcha onVerification={setIsVerified} reset={resetCaptcha} />
          </div>

          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              className="readMoreButton"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TankerBooking;
